import React, {useEffect, useState} from 'react';
import {FaArrowLeft, FaArrowRight} from "react-icons/fa";
import Slider from "react-slick";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {useParams} from "react-router-dom";
import {fetchProductDetail} from "../actions/product";
import {useDispatch, useSelector} from "react-redux";
import {PICTURES_PATH} from "../utils/consts";
import {parseImg} from "../utils/parseImg";

const ProductArea = () => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const productFetch = useSelector(state => state.productDetail.product) || {};
    const [countProduct, setCountProduct] = useState(1);
    const isModalOpen = useSelector(state => state.modalForm.show);

    const [aImg, setAImg] = useState([]);
    const [currentImg, setCurrentImg] = useState(null);
    useEffect(() => {
        dispatch(fetchProductDetail(id));
        dispatch({type: 'HIDE_MODAL'});
    }, [id]);

    useEffect(() => {
        if (productFetch.img) {
            const parsedImages = parseImg(productFetch.img) || [];
            setAImg(parsedImages);
            setCurrentImg(parsedImages[0] || null); // Устанавливаем первый элемент или `null`
        }
    }, [productFetch.img]);

    const PrevArrow = ({onClick}) => (
        <button className="slick-arrow-gallery prev" onClick={onClick}>
            <IoIosArrowBack color="#fff"/>
        </button>
    );

    // Кастомная кнопка "вперёд"
    const NextArrow = ({onClick}) => (
        <button className="slick-arrow-gallery next" onClick={onClick}>
            <IoIosArrowForward color="#fff"/>
        </button>
    );

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: <PrevArrow/>, // Кастомная кнопка назад
        nextArrow: <NextArrow/>  // Кастомная кнопка вперёд
    };

    const handleChange = (e) => {
        if (e.target.value === "") {
            setCountProduct(""); // Разрешаем пустое поле временно
        } else {
            const newValue = Math.max(1, Number(e.target.value)); // Гарантируем минимум 1
            setCountProduct(newValue);
        }

    };

    const showModalForm = () => {
        dispatch({type: 'SHOW_MODAL_FORM', payload: {
                amount: countProduct
            }});
    }

    useEffect(() => {
        isModalOpen ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open");
    }, [isModalOpen])
    return (
        <div className="product_details mt-50 mb-90">
            <div className="container">
                <div className="row" itemScope itemType="https://schema.org/Product">
                    <div className="col-lg-6 col-md-6">
                        <div className="product-details-tab">
                            <div id="img-1" className="zoomWrapper single-zoom">
                                <img itemProp="image" className="product-details-tab-img"
                                     src={`${PICTURES_PATH}product/${currentImg || aImg[0]}`} alt={productFetch.title}/>
                            </div>
                            <div className="single-zoom-thumb">
                                <ul>
                                    <Slider {...settings}>
                                        {aImg.map((elem, index) => (
                                            <li key={index}>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentImg(elem);
                                                }}>
                                                    <img className="product-details-tab-under-img"
                                                         src={`${PICTURES_PATH}product/${elem}`} alt={productFetch.title}/>
                                                </a>
                                            </li>
                                        ))}
                                    </Slider>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="product_d_right">
                            <form>
                                <h1 itemProp="name">{productFetch.title}</h1>
                                <div className="price_box" itemProp="offers" itemScope itemType="https://schema.org/Offer">
                                    <span itemProp="price" className="current_price">{productFetch.price}</span>
                                    <meta itemProp="priceCurrency" content="RUB" />
                                    <link itemProp="availability" href="https://schema.org/InStock" />
                                    <link itemProp="url" href={window.location.href} />
                                </div>
                                <div className="product_desc">
                                    <p itemProp="description">{productFetch.description}</p>
                                </div>
                                <div className="product_variant color">
                                    <h3>Характеристики</h3>
                                    <div className="product_meta">
                                        <p>Порода древесины: <span>{productFetch.species}</span></p>
                                        <p>Категория: <span>{productFetch.sort}</span></p>
                                        <p>Сечение: <span>{productFetch.size}</span></p>
                                    </div>
                                </div>
                                <div className="product_variant quantity">
                                    <label htmlFor="quantity">Количество</label>
                                    <input id="quantity" min="0" onChange={handleChange} value={countProduct} type="number"
                                           inputMode="numeric" pattern="\d*"/>
                                    <button className="button" onClick={(e) => {
                                        e.preventDefault();
                                        showModalForm();
                                    }}>Заказать</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductArea;